/*!
 * jb-cart.js — Jellybean cart utilities
 */
(function () {
  'use strict';

  /* ---- 1. Merge duplicate line items ---- */
  async function mergeCartDuplicates() {
    try {
      var res = await fetch('/cart.js');
      var contentType = res.headers.get('content-type') || '';
      if (!res.ok || contentType.indexOf('application/json') === -1) return;
      var cart = await res.json();
      if (!cart.items || cart.items.length <= 1) return;
      var quantitiesByVariant = {};
      var hasDupes = false;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var properties = item.properties || {};

        // Bundle components deliberately use unique properties so separate
        // customer-built sets never collapse into one another.
        if (properties._bundle || properties._bundle_id) continue;

        var propertyKeys = Object.keys(properties).sort();
        var propertySignature = propertyKeys.map(function(key) {
          return key + ':' + String(properties[key]);
        }).join('|');
        var fingerprint = item.variant_id + '|' + propertySignature;

        if (quantitiesByVariant[fingerprint]) hasDupes = true;
        quantitiesByVariant[fingerprint] = quantitiesByVariant[fingerprint] || {
          key: item.key,
          quantity: 0
        };
        quantitiesByVariant[fingerprint].quantity += item.quantity;
      }
      if (!hasDupes) return;

      var updates = {};
      Object.keys(quantitiesByVariant).forEach(function(fingerprint) {
        var entry = quantitiesByVariant[fingerprint];
        updates[entry.key] = entry.quantity;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } catch (e) { console.warn('[jb-cart merge]', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeCartDuplicates);
  } else {
    mergeCartDuplicates();
  }

  /* ---- 2. Reconcile cart lines that became unavailable in this market ---- */
  var reconciliationInFlight = false;

  async function reconcileUnavailableLines() {
    if (reconciliationInFlight) return;

    var lines = document.querySelectorAll('[data-jb-cart-reconcile]');
    if (!lines.length) return;

    var updates = {};
    lines.forEach(function(line) {
      var key = line.getAttribute('data-item');
      var quantity = parseInt(line.getAttribute('data-jb-cart-reconcile-quantity'), 10);
      if (key && !isNaN(quantity)) updates[key] = Math.max(0, quantity);
    });
    if (!Object.keys(updates).length) return;

    reconciliationInFlight = true;
    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) throw new Error('Cart reconciliation failed.');

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (error) {
      console.warn('[jb-cart market reconciliation]', error);
    } finally {
      reconciliationInFlight = false;
    }
  }

  function queueUnavailableLineReconciliation() {
    window.setTimeout(reconcileUnavailableLines, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUnavailableLineReconciliation);
  } else {
    queueUnavailableLineReconciliation();
  }
  document.addEventListener('theme:product:added', queueUnavailableLineReconciliation);
  document.addEventListener('theme:cart:change', queueUnavailableLineReconciliation);

})();

/* ============================================================
   3. Discount code apply
   Removal is handled by Broadcast's native [data-remove-discount] button
   rendered in snippets/cart-price.liquid — do NOT intercept it here.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Per-drawer initialisation ---- */
  function initDiscount() {
    var input = document.getElementById('jb-discount-code');
    var btn   = document.getElementById('jb-discount-apply');
    var msg   = document.getElementById('jb-discount-msg');
    if (!input || !btn || input.dataset.jbInit) return;
    input.dataset.jbInit = '1';

    function setMsg(text, type) {
      msg.textContent = text;
      msg.className = 'jb-discount__msg jb-discount__msg--' + (type || '');
    }

    async function applyCode() {
      var code = (input.value || '').trim();
      if (!code) { setMsg('Please enter a discount code.', 'error'); return; }

      btn.disabled = true;
      btn.textContent = 'Applying\u2026';
      setMsg('', '');

      try {
        /* Apply via session URL so Shopify registers it before we check cart */
        await fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET', redirect: 'follow', credentials: 'same-origin'
        });

        /* Register with cart/update.js so Broadcast's native removal button  */
        /* recognises the code and can clear it cleanly                       */
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: code })
        });

        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        var applied = (cart.cart_level_discount_applications || []).some(function(d) {
          return (d.title || '').toLowerCase() === code.toLowerCase() ||
                 (d.code  || '').toLowerCase() === code.toLowerCase();
        });

        if (applied) {
          setMsg('\u2713 ' + code.toUpperCase() + ' applied!', 'success');
          /* Refresh so Broadcast re-renders the native discount display row */
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else {
          setMsg('Code not recognised. Please check and try again.', 'error');
          btn.disabled = false;
          btn.textContent = 'Apply';
          return;
        }
      } catch (e) {
        setMsg('Something went wrong. Please try again.', 'error');
      }

      btn.disabled = false;
      btn.textContent = 'Apply';
    }

    btn.addEventListener('click', applyCode);
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); applyCode(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscount);
  } else {
    initDiscount();
  }
  /* Re-initialise after drawer opens or Broadcast re-renders the cart */
  document.addEventListener('theme:cart-drawer:open', function() {
    setTimeout(initDiscount, 100);
  });
  document.addEventListener('theme:cart:refresh', function() {
    setTimeout(initDiscount, 300);
  });

})();

/* ============================================================
   4. QTY label — shows "QTY X" below price for qty > 1
   ============================================================ */
(function () {
  'use strict';

  function addQtyLabels() {
    document.querySelectorAll('.cart__item').forEach(function(item) {
      // Remove stale label first
      var old = item.querySelector('.jb-qty-label');
      if (old) old.remove();

      var qtyInput = item.querySelector('.cart__quantity-field, input[name="updates[]"], input[data-quantity-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (isNaN(qty) || qty <= 1) return;

      var priceEl = item.querySelector('.cart__item__price, .cart__item__content__right');
      if (!priceEl) return;

      var label = document.createElement('div');
      label.className = 'jb-qty-label';
      label.textContent = 'QTY ' + qty;
      priceEl.appendChild(label);
    });
  }

  function run() {
    addQtyLabels();
    setTimeout(addQtyLabels, 600);
    setTimeout(addQtyLabels, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('theme:cart:refresh',     run);
  document.addEventListener('theme:cart-drawer:open', run);

  var debounce = null;
  var qtyObserverTarget = document.querySelector('cart-drawer, .drawer--cart') || document.body;
  new MutationObserver(function(m) {
    for (var i = 0; i < m.length; i++) {
      if (m[i].addedNodes.length) {
        clearTimeout(debounce);
        debounce = setTimeout(addQtyLabels, 200);
        break;
      }
    }
  }).observe(qtyObserverTarget, { childList: true, subtree: true });

})();

/* ============================================================
   5. Cart Upsell — Little Loungers
   ============================================================ */
(function () {
  'use strict';

  var COLLECTION = 'the-little-loungers-collection';
  var UPSELL_ID  = 'jb-upsell';
  var mountTimer = null;
  var lastCartState = null; // Option 5: cart-state guard

  function formatMoney(priceStr) {
    return '$' + parseFloat(priceStr).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function hasRealVariants(product) {
    return product.variants.length > 1 ||
           (product.variants.length === 1 && product.variants[0].title !== 'Default Title');
  }

  async function fetchProducts() {
    // Use block-configured data (set by little-loungers block in cart-drawer.liquid)
    var cfg = window.JBUpsellConfig;
    if (cfg && cfg.products && cfg.products.length) {
      return cfg.products;
    }
    // Fallback: public storefront API (only works without password protection)
    try {
      var res = await fetch('/collections/' + COLLECTION + '/products.json?limit=50');
      var data = await res.json();
      return data.products || [];
    } catch (e) { return []; }
  }

  async function fetchCart() {
    var res = await fetch('/cart.js');
    return res.json();
  }

  function renderCardBody(product) {
    var cfg        = window.JBUpsellConfig || {};
    var img        = product.images && product.images[0] ? product.images[0].src : '';
    var firstAvail = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    var variantEl  = '';

    if (hasRealVariants(product)) {
      variantEl = '<select class="jb-upsell__variant" data-upsell-variant>';
      product.variants.forEach(function(v) {
        variantEl += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>'
                   + v.title + (v.available ? '' : ' – Sold out') + '</option>';
      });
      variantEl += '</select>';
    } else {
      variantEl = '<input type="hidden" data-upsell-variant value="' + firstAvail.id + '">';
    }

    return '<div class="jb-upsell__card" data-upsell-card>'
      + (img ? '<img class="jb-upsell__img" src="' + img + '" alt="' + product.title + '" width="36" height="36" loading="lazy">' : '')
      + '<div class="jb-upsell__info">'
      +   '<p class="jb-upsell__name">' + product.title + '</p>'
      +   '<p class="jb-upsell__price">+ ' + formatMoney(firstAvail.price) + '</p>'
      +   variantEl
      + '</div>'
      + '<button class="jb-upsell__btn" data-upsell-add data-product-id="' + product.id + '">' + (cfg.preorderMode ? (cfg.preorderButtonText || 'Preorder Now') : 'Add') + '</button>'
      + '</div>';
  }

  function renderCard(product, heading) {
    return '<p class="jb-upsell__label">' + heading + '</p>' + renderCardBody(product);
  }

  async function initUpsell() {
    var container = document.getElementById(UPSELL_ID);
    if (!container) return;

    var cfg        = window.JBUpsellConfig || {};
    var heading    = cfg.heading || 'Popular Addons';
    var scrollable = cfg.scrollable || false;

    var results  = await Promise.all([fetchProducts(), fetchCart()]);
    var products = results[0];
    var cart     = results[1];

    var inCart = new Set((cart.items || []).map(function(i) { return i.product_id; }));
    var pool   = products.filter(function(p) { return p.available && !inCart.has(p.id); });

    if (pool.length === 0) {
      container.innerHTML = '<p class="jb-upsell__label">' + heading + '</p>'
        + '<p class="jb-upsell__empty">You\'ve got them all! 🎉</p>';
      return;
    }

    if (scrollable) {
      var html = '<p class="jb-upsell__label">' + heading + '</p>'
        + '<div class="jb-upsell__scroll-wrap">';
      pool.forEach(function(p) { html += renderCardBody(p); });
      html += '</div>';
      container.innerHTML = html;
    } else {
      var product = pool[Math.floor(Math.random() * pool.length)];
      container.innerHTML = renderCard(product, heading);
    }

    container.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
      btn.addEventListener('click', async function () {
        var card      = btn.closest('[data-upsell-card]') || container;
        var variantEl = card.querySelector('[data-upsell-variant]');
        var variantId = variantEl ? parseInt(variantEl.value) : null;
        if (!variantId) return;

        btn.disabled    = true;
        btn.textContent = 'Adding...';

        try {
          var properties = {};
          if (cfg.preorderMode && cfg.preorderPropertyName) {
            properties[cfg.preorderPropertyName] = cfg.preorderPropertyValue;
          }
          var upsellItem = { id: variantId, quantity: 1 };
          if (Object.keys(properties).length) upsellItem.properties = properties;

          var res = await fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify({ items: [upsellItem] })
          });
          if (!res.ok) throw new Error('failed');

          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          setTimeout(initUpsell, 500);
        } catch (e) {
          btn.disabled    = false;
          btn.textContent = 'Add';
        }
      });
    });
  }

  function mountUpsell() {
    clearTimeout(mountTimer);
    mountTimer = setTimeout(function () {
      // #jb-upsell is pre-rendered by Liquid (little-loungers block)
      if (!document.getElementById(UPSELL_ID)) return;

      // Skip re-fetch if cart total & item count haven't changed
      var cartTotalEl = document.querySelector('[data-cart-total]');
      var cartState = cartTotalEl
        ? cartTotalEl.dataset.cartTotal + ':' + document.querySelectorAll('.cart__item').length
        : null;
      if (cartState && cartState === lastCartState) return;
      lastCartState = cartState;

      initUpsell();
    }, 150);
  }

  document.addEventListener('DOMContentLoaded',       mountUpsell);
  document.addEventListener('theme:cart:refresh',     mountUpsell);
  document.addEventListener('theme:cart-drawer:open', mountUpsell);
  document.addEventListener('cart:updated',           mountUpsell);

})();

/* ============================================================
   6. Checkout+ (Redo) — strip price from checkout button text
   Redo renders AFTER the cart opens (native button shows first, then
   Redo replaces it). The price lives in:
     redo-shopify-toggle [data-target="headline-text-container"] p
   We run a 200ms interval while the cart is open to scrub "| $X.XX"
   from that <p> as soon as Redo writes it. Stops on cart close.
   ============================================================ */
(function () {
  'use strict';

  function scrubRedoPrice() {
    var p = document.querySelector('redo-shopify-toggle [data-target="headline-text-container"] p');
    if (!p) return;
    var txt = p.textContent || '';
    var pipeIdx = txt.indexOf(' | ');
    if (pipeIdx > -1) {
      p.textContent = txt.substring(0, pipeIdx).trim();
    }
  }

  var _redoInterval = null;

  function startScrubber() {
    if (_redoInterval) return;
    _redoInterval = setInterval(scrubRedoPrice, 200);
  }

  function stopScrubber() {
    if (_redoInterval) {
      clearInterval(_redoInterval);
      _redoInterval = null;
    }
  }

  // Poll every 500ms while the cart drawer is open.
  // If redo-shopify-toggle is missing, re-fire theme:cart-drawer:open so Redo
  // re-injects itself. A 3s cooldown prevents rapid repeat fires.
  // This handles item removal, qty change, discount apply, and any other
  // Broadcast re-render that wipes Redo's injected element.
  var _redoPoll = null;
  var _redoReinjectAt = 0;
  var _noButtonRefreshAt = 0;

  function _checkRedo() {
    var drawer = document.querySelector('cart-drawer.is-open');
    if (!drawer) { _stopRedoPoll(); return; }
    if (document.querySelector('redo-shopify-toggle')) return; // all good

    // Safety net: if neither Redo NOR the native checkout button is present,
    // the customer has no way to checkout. Force a full cart refresh to restore
    // Broadcast's native button. This handles cases where Redo hides the native
    // button but then decides not to inject its own (ineligible products, etc).
    var hasNativeCheckout = !!drawer.querySelector('button[name="checkout"]');
    if (!hasNativeCheckout) {
      if (Date.now() > _noButtonRefreshAt) {
        _noButtonRefreshAt = Date.now() + 5000;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }
      return;
    }

    if (Date.now() < _redoReinjectAt) return;                  // cooldown
    _redoReinjectAt = Date.now() + 3000;
    // Redo watches for the is-open class being ADDED (MutationObserver),
    // not the event. Remove is-open then immediately reopen so the class
    // transition fires and Redo re-injects into the fresh cart HTML.
    if (typeof drawer.openCartDrawer !== 'function') return;
    drawer.classList.remove('is-open');
    requestAnimationFrame(function () { drawer.openCartDrawer(); });
  }

  function _startRedoPoll() {
    if (_redoPoll) return;
    _redoPoll = setInterval(_checkRedo, 500);
  }

  function _stopRedoPoll() {
    clearInterval(_redoPoll);
    _redoPoll = null;
  }

  document.addEventListener('theme:cart-drawer:open',  _startRedoPoll);
  document.addEventListener('theme:cart-drawer:close', _stopRedoPoll);
  if (document.querySelector('cart-drawer.is-open')) _startRedoPoll();

  // Run immediately on cart open, stop on cart close
  document.addEventListener('theme:cart-drawer:open',  startScrubber);
  document.addEventListener('theme:cart-drawer:close', stopScrubber);

  // Also cover theme:cart:refresh (discount applied/removed)
  document.addEventListener('theme:cart:refresh', scrubRedoPrice);

  // If cart is already open on page load
  if (document.querySelector('cart-drawer.is-open')) startScrubber();

})();

/* ============================================================
   7. SS Bundle Builder — intercept form POST → cart drawer
   Catches any form[data-type="add-to-cart-form"] (Section Store's
   bundle builder) and converts the native POST to AJAX so Broadcast's
   cart drawer opens instead of navigating to /cart.
   ============================================================ */
(function () {
  'use strict';

  function interceptSSBundle() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      if (form._jbIntercepted) return;
      form._jbIntercepted = true;

      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        var originalText = btn ? (btn.getAttribute('data-all') || btn.textContent.trim()) : '';

        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding\u2026';
        }

        /* Collect items from hidden inputs: items[N][id] / items[N][quantity] */
        var itemMap = {};
        new FormData(form).forEach(function (val, key) {
          var m = key.match(/^items\[(\d+)\]\[(\w+)\]$/);
          if (m) {
            var idx = m[1], prop = m[2];
            if (!itemMap[idx]) itemMap[idx] = {};
            itemMap[idx][prop] = val;
          }
        });

        var items = Object.keys(itemMap).sort().reduce(function (arr, idx) {
          var item = itemMap[idx];
          if (item.id && item.quantity) {
            var cartItem = { id: parseInt(item.id, 10), quantity: parseInt(item.quantity, 10) };
            var preorderCfg = window.JBUpsellConfig || {};
            if (preorderCfg.preorderMode && preorderCfg.preorderPropertyName) {
              cartItem.properties = {};
              cartItem.properties[preorderCfg.preorderPropertyName] = preorderCfg.preorderPropertyValue;
            }
            arr.push(cartItem);
          }
          return arr;
        }, []);

        if (!items.length) {
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
          return;
        }

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) throw new Error('add failed');

          // Tell Broadcast to refresh the cart, then open the drawer only
          // AFTER Broadcast's fetch+render is done (so Redo injects into
          // stable HTML rather than stale HTML that gets wiped by the refresh).
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

          function openDrawer() {
            window._jbLastDrawerOpen = Date.now();
            var d = document.querySelector('cart-drawer');
            if (!d || typeof d.openCartDrawer !== 'function') return;
            // If Broadcast already opened the drawer during theme:cart:refresh,
            // is-open is already set and openCartDrawer() returns early without
            // triggering Redo. Strip is-open first, then reopen so Redo's
            // MutationObserver fires on the class transition.
            if (d.classList.contains('is-open')) {
              d.classList.remove('is-open');
              requestAnimationFrame(function () { d.openCartDrawer(); });
            } else {
              d.openCartDrawer();
            }
          }

          // Open the drawer once the cart has re-rendered, then fire the
          // open event a second time ~1s later so Redo gets a fresh injection
          // opportunity after any secondary re-renders (e.g. SS Bundle app JS).
          var opened = false;
          if (window.subscribe) {
            var unsub4 = window.subscribe('cart-update', function () {
              if (opened) return;
              opened = true;
              unsub4();
              openDrawer();
            });
          }
          // Fallback
          setTimeout(function () {
            if (opened) return;
            opened = true;
            openDrawer();
          }, 1200);

          if (btn) {
            btn.textContent = '\u2713 Added!';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 2500);
          }
        } catch (err) {
          console.error('[jb-cart] SS bundle add failed:', err);
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Error \u2014 please try again';
            setTimeout(function () { btn.textContent = originalText; }, 3000);
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptSSBundle);
  } else {
    interceptSSBundle();
  }
  document.addEventListener('shopify:section:load', interceptSSBundle);

  /* ============================================================
     8. Optimistic cart item removal
     Immediately fades out the item on remove click so the cart
     feels instant. Broadcast's native AJAX still runs and
     reconciles the cart in the background.
     ============================================================ */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-item-remove]');
      if (!btn) return;

      var item = btn.closest('[data-item]') || btn.closest('.cart__item');
      if (!item) return;

      // Instantly collapse the item height and fade it out
      item.style.transition = 'opacity 0.2s ease, transform 0.2s ease, max-height 0.25s ease';
      item.style.overflow = 'hidden';
      item.style.opacity = '0';
      item.style.transform = 'translateX(-8px)';
      item.style.maxHeight = item.offsetHeight + 'px';

      requestAnimationFrame(function () {
        item.style.maxHeight = '0';
        item.style.marginBottom = '0';
        item.style.paddingTop = '0';
        item.style.paddingBottom = '0';
      });
    }, true); // capture phase so it runs before Broadcast's handler
  })();

  /* ============================================================
     9. Keep remove buttons always clickable during cart refresh
     Broadcast's disableCartButtons() sets the `disabled` attr on
     ALL buttons (including [data-item-remove]) via setAttribute.
     We use a MutationObserver to immediately strip it off remove
     buttons so the user can queue sequential item removals without
     the 1–2 second lockout.
     ============================================================ */
  (function () {
    // Visual override — ensure remove buttons never dim/lock
    var s = document.createElement('style');
    s.textContent =
      '[data-item-remove]{pointer-events:auto!important;opacity:1!important;}';
    document.head.appendChild(s);

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.attributeName === 'disabled') {
          var el = m.target;
          if (el.hasAttribute('data-item-remove')) {
            el.removeAttribute('disabled');
          }
        }
      }
    });

    function startObserving() {
      obs.observe(document.body, {
        attributes: true,
        attributeFilter: ['disabled'],
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  })();

})();
